import Vue from 'vue';
import firebase from 'firebase/app';
import Router from 'vue-router';
import Home from './views/Home.vue';
import SignUp from './views/SignUp.vue';
import Login from './views/Login.vue';
import Logout from './views/Logout.vue';
import Upload from './views/Upload.vue';
import EarlyAccess from './views/EarlyAccess.vue';
import Paper from './views/Paper.vue';
import About from './views/About.vue';
import Feedback from './views/Feedback.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/paper/:paperid',
      name: 'paper',
      component: Paper,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp,
    },
    {
      path: '/earlyaccess',
      name: 'earlyaccess',
      component: EarlyAccess,
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/upload',
      name: '/upload',
      component: Upload,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: Feedback,
    }
  ],
});

router.beforeEach((to, from, next) => {
  const { currentUser } = firebase.auth();
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  try {
    mixpanel.track("pageview", {"name": to.name, "url": to.path})
  } catch {}
  if (requiresAuth && !currentUser) next('login');
  else next();
});

export default router;
